import React from "react";
import ReactDOM from "react-dom";
import Animate from "rc-animate";
import filter from "lodash/filter";
import Notice from "./Notice";

let seed = 0;

class AlertGroup extends React.Component {
  state = {
    alerts: []
  };

  onEnd = key => {
    const { alerts } = this.state;
    this.setState({
      alerts: filter(alerts, alert => alert.key !== key)
    });
  };

  addAlert = a => {
    this.setState({
      alerts: this.state.alerts.concat(a)
    });
  };

  render() {
    const { alerts } = this.state;
    const children = alerts.map(a => {
      if (!a.key) {
        seed++;
        a.key = String(seed);
      }
      return <Notice {...a} onEnd={() => this.onEnd(a.key)} />;
    });

    return (
      <div className="notice-group">
        <Animate transitionAppear transitionName="move-up" component="div">
          {children}
        </Animate>
      </div>
    );
  }
}

const alertGroup = new Map();

function alert(content, time, type, target = document.body) {
  let group = alertGroup.get(target);
  if (!group) {
    const div = document.createElement("div");
    document.body.appendChild(div);
    group = ReactDOM.render(<AlertGroup />, div);
    alertGroup.set(target, group);
  }
  group.addAlert({
    content,
    time,
    type
  });
}

export default {
  success: (info, time = 3000, target) => alert(info, time, "success", target),
  error: (info, time = 9000, target) => alert(info, time, "error", target),
  warning: (info, time = 3000, target) => alert(info, time, "warning", target)
};
